import WorkoutLive from './WorkoutLive';

export default WorkoutLive;
